import { Drawer } from '@material-ui/core';
import * as React from 'react';
import { StatusCode } from '../../../../utils/api';
import { AppUtils } from '../../../../utils/app-utils';
import { ShipmentType } from '../../../models/enums/shipment-type';
import { RunningTotal } from '../../../models/shared/running-total';
import { DeliveryShipmentAction } from '../../../models/shipments/shipment-action';
import { TransportationSvc } from '../../../service';
import { ShipmentEditCustomerDelivery } from '../ShipmentEditCustomerDelivery';
import { ShipmentStatus } from '../../../models/enums/shipment-status';

interface IProps {
    visible         : boolean;
    onClose         : any;
    onSuccess       : any;
    truckId         : number;
    truckVersion    : string;
    stop            : DeliveryShipmentAction|undefined;
    truckTotals     : RunningTotal|undefined;
    entityType      : ShipmentType;
    shipmentStatus? : ShipmentStatus;
    serviceCenterId : string;
}

export const ActionEditCustomerDelivery = (props: IProps) => {

    const [service] = React.useState(new TransportationSvc());
    const [editStop, setEditStop] = React.useState<DeliveryShipmentAction>(new DeliveryShipmentAction());

    /**
     * Hydrate the required properties for editing
     */
    React.useEffect(() => {
        if (props.visible && props.stop) {
            const tmpStop = { ...props.stop };
            // tmpStop.isFixedFreight = tmpStop.fixedFreightAmount ? true : false;
            setEditStop(tmpStop);
        }
    }, [props.visible]);

    /**
     * Close handler for the flyout
     */
    const onClose = () => {
        setEditStop({} as unknown as DeliveryShipmentAction);
        props.onClose();
    };

    /**
     * Save the schedule back to the server, and if successful
     * close the flyout
     */
    const onSave = async (stopToUpdate: DeliveryShipmentAction) => {

        const result = await service.updateStop(
            stopToUpdate,
            props.truckId,
            props.truckVersion,
            props.entityType
        );

        if (result.status === StatusCode.Success) {
            setEditStop({} as unknown as DeliveryShipmentAction);
            props.onSuccess();
        }
    };

    return <Drawer
        anchor="right"
        onClose={onClose}
        open={props.visible}>
        {
            !AppUtils.IsEmpty(editStop)
                ? <div className="stop-action-drawer stop-action-edit-delivery">
                    <ShipmentEditCustomerDelivery
                        stop={editStop}
                        orderList={undefined}
                        onSave={onSave}
                        onCancel={onClose}
                        changeAddress={undefined}
                        isQuickCreate={false}
                        entityType={props.entityType}
                        visible={props.visible}
                        truckId={props.truckId}
                        truckVersion={props.truckVersion}
                        truckTotals={props.truckTotals}
                        shipmentStatus={props.shipmentStatus}
                        serviceCenterId={props.serviceCenterId}
                    />
                </div>
                : null
        }
    </Drawer>;
};
